"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdk = void 0;
const elementPropsSDKFactory_1 = require("../props-factories/elementPropsSDKFactory");
const composeSDKFactories_1 = require("../composeSDKFactories");
const elementPropsSDKFactory = (0, elementPropsSDKFactory_1.createElementPropsSDKFactory)();
exports.sdk = (0, composeSDKFactories_1.composeSDKFactories)(elementPropsSDKFactory);
exports.default = exports.sdk;
//# sourceMappingURL=Fallback.corvid.js.map